import { createSelector } from 'reselect';

import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import { TState } from '~/src/store';

/** Возвращает выбранные shopItems, по категории
 * @param state {TState} - стор
 * @param category {string} - категория товара
 */
export const getSelectedProductsByCategory = (category?: EShopCategory) => createSelector(
    [
      (state: TState) => ({ items: state.fullBuy.products, category }),
    ],
    ({ items, category }) => {
        if (!items) {
            return [];
        }

        return category
            ? items.filter(item => item.category === category && item.quantity > 0)
            : items.filter(item => item.quantity > 0);
    },
);
